export const IS_LOCALHOST =
  window.location.origin.includes('localhost') ||
  window.location.origin.includes('127.0.0.1');

export const ENTRYPOINT = IS_LOCALHOST
  ? 'http://localhost:8000'
  : window.location.origin + '/app';
